import type { FaireProductEntity } from "../../entity_types/product";

export const p_9dyqmq3rm4: FaireProductEntity = {
  token: "p_9dyqmq3rm4",
  type: "product",
  name: "Barbican Cocktail Strainer",
  brandToken: "b_dtfc7uc37e",
  brandName: "Aaron Probyn US",
  imageUrl:
    "https://cdn.faire.com/fastly/6476c9b49f5b80f69ca653f225cc346dd6aab1810dd477bf3fc5c79583029ab5.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ae7865927500e04e60284dbbcd14dc032a7b3465bf48e293a6beb68105b8124c.jpeg",
    "https://cdn.faire.com/fastly/e3c7576a838327599606192a9a67a48ad53190238e59f896dfde725fac7a4b84.jpeg",
    "https://cdn.faire.com/fastly/32a199c03098d3df41c2b5e8616d4c12d09130a119d8fba936825e506ab64cf2.jpeg",
    "https://cdn.faire.com/fastly/721d1cc62caff101d942a72a636d741a94a4328eafc5b68f85b4da5e0f3a6471.jpeg",
    "https://cdn.faire.com/fastly/e5471de25e3b9685cab92e709f23d95e5ecfaae06581d4fb5aaea8f855a38702.jpeg",
    "https://cdn.faire.com/fastly/ca72b920ac22c45cb5853b7af77dfad59d9b18ab32858c201429e6744195d34d.jpeg",
    "https://cdn.faire.com/fastly/d6f96e0c65d6df8df49ac7d136cc6179a94dfb7228c557abf71dae94f296d720.jpeg",
    "https://cdn.faire.com/fastly/deadf440d8f3222e4e77a8761c66f01da6dd8dc62c27c024f51a8d0c3662b199.jpeg",
  ],
  priceDollars: 20,
  description:
    "BARBICAN is a barware collection inspired by the bold lines and functionality of brutalist architecture.\n\nThe BARBICAN Strainer Spoon is a modern take on the classic julep-style form. Designed to sit neatly within the BARBICAN Shaker, it strains with ease while echoing the graphic, sculptural lines of the range. Skillfully crafted from high-grade stainless steel.\n\nMaterial: 18/0 stainless steel\nSize: 10 x 13.3 x 1.6cm / 3.9” x 5.2 x 0.6”\n\nDishwasher-safe, handwash recommended",
  tags: [],
  msrpDollars: 40,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-04T23:53:31.130Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
